import { render, staticRenderFns } from "./CredenciamentoFornecedorPropostaItem.vue?vue&type=template&id=5d960c91"
import script from "./CredenciamentoFornecedorPropostaItem.vue?vue&type=script&lang=js"
export * from "./CredenciamentoFornecedorPropostaItem.vue?vue&type=script&lang=js"
import style0 from "./CredenciamentoFornecedorPropostaItem.vue?vue&type=style&index=0&id=5d960c91&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports